import React, { useRef, useState, useEffect } from 'react'
import UseParseDateMonthYearTime from '../../../../hooks/UseParseDateMonthYearTime';
import UseParseYearMonthDate from '../../../../hooks/UseParseYearMonthDate';

import classes from "./HolidayModeCardContentLayout.module.css"

import arrowIcon from "../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Page - Forward.svg";
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../../Modal/Modal';
import TimeDatePicker from '../../../TimeDatePicker/TimeDatePicker';
import StatePicker from './StatePicker';
import ToggleInput from '../../../ToggleInput';
import Button1 from '../../../Button/Button1';
import { deleteHolidayModeAPI, editHolidayModeAPI } from '../../../../../Api Methods/Api';
import { format } from 'date-fns';
import RuleCard from '../../Rules/RuleCard';
import UseDisplayUserName from '../../../../hooks/UseDisplayUserName';
import { UseIsTempScheduleStartValid, TEMP_SCHEDULE_START_ERROR } from '../../../../hooks/UseValidateTempScheduleStart';


const HolidayModeCardContentLayout = ({ holdiayMode, OutPutsPinNames, smartLocks, fetchAutomations }) => {
  const isStatusActive = true;

  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
  const role = useSelector(state => state.auth.role);

  const createdBy = holdiayMode.createdBy
  const dateCreated = holdiayMode.dateCreated

  const apiData = {
    token,
    client
  }

  //------------------------------- Modal Logic  ----------------------------------------------

  const ModalDialog = useRef();

  // call ref to clearStates method from child component ScheduledAction.
  const ClearStatesChildComponetRef = useRef();

  const HandleShowModal = () => {
    ModalDialog.current.open();
  }

  const [modalTitle, setModalTitle] = useState("Edit temporary schedule");
  //--------------------------------------------------------------------------------------------

  const activeButtonRef = useRef();

  const [isHolidayModeActive, setIsHolidayModeActive] = useState(holdiayMode.active);

  const [latchPins, setLatchPins] = useState();


  // Initialize state with current time
  const [holidayModeDetails, setHolidayModeDetails] = useState(holdiayMode);

  const HandleCloseModal = () => {
    ModalDialog.current.close();

    //reset model screen
    HandelResetModal();
  }

  // Handler for time change
  const HandleStartOn = (dateTime) => {
    setHolidayModeDetails(prevState => ({
      ...prevState, // Spread the previous state to keep other properties unchanged
      start: dateTime // Update only the start property
    }));
  };

  const HandleEndOn = (datetime) => {
    setHolidayModeDetails(prevState => ({
      ...prevState,
      end: datetime
    }));
  };

  const HandleOutputState = (pin, state) => {
    const states = holidayModeDetails.states
    states[pin] = state;

    setHolidayModeDetails(prevState => ({
      ...prevState, // Spread the previous state to keep other properties unchanged
      "states": states // Update only the start property
    }));
  }

  //updates the active property within holidayModeDetails
  useEffect(() => {
    setHolidayModeDetails(prevState => ({
      ...prevState, // Spread the previous state to keep other properties unchanged
      "active": isHolidayModeActive // Update only the start property
    }));
  }, [isHolidayModeActive])

  const dispatch = useDispatch();
  
  // The start can't be moved into the past / within the next 5 minutes. Only enforced when the start is actually changed -
  // a schedule that's already running has a start in the past, and that mustn't block editing its end time, outputs or active state.
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 15000);
    return () => clearInterval(interval);
  }, []);

  const isStartChanged = holidayModeDetails.start !== holdiayMode.start;
  const isStartInvalid = isStartChanged && !UseIsTempScheduleStartValid(holidayModeDetails.start, holdiayMode.timezone, now);

  const HandleEditHolidayMode = async (event) => {
    event.preventDefault()

    if (isStartChanged && !UseIsTempScheduleStartValid(holidayModeDetails.start, holdiayMode.timezone)) {
      setNow(Date.now()); // refreshes validation so the error shows
      return;
    }

    if (holidayModeDetails.start != holidayModeDetails.end) {
      // the update endpoint doesn't accept a timezone value - a holiday mode's timezone is fixed at creation and can't be changed via edit
      const { timezone, ...bodyWithoutTimezone } = holidayModeDetails;
      const response = await editHolidayModeAPI(apiData, bodyWithoutTimezone, dispatch);
      if (response && response.success) {
        HandleCloseModal();
        fetchAutomations();
      }
    }

  }

  const HandleRemoveHolidayMode = async (event) => {
    const response = await deleteHolidayModeAPI(apiData, holidayModeDetails.id, dispatch);
    if (response && response.success) {
      HandleCloseModal();
      fetchAutomations();
    }
  }

  // reset model when Escape key is pressed
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        // Handle the Escape key press here
        HandleCloseModal();
      }
    };

    // Add event listener when component mounts
    document.addEventListener('keydown', handleKeyDown);


    // Clean up event listener when component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const HandelResetModal = () => {
    setHolidayModeDetails(holdiayMode)
  }


  useEffect(() => {

    //removed to match app availablePins
    // Filter for only active pins && pins with type of latch 
    // const availablePins = OutPutsPinNames.filter(outPut => outPut.active == '1' && outPut.type == 'LATCH');

    // outputs with a smart lock (BLE padlock) linked can't be armed/disarmed by a schedule - keep them out of the options.
    // (previously `smartLocks.some(lock => pin != lock.outputPin)`, which only excluded anything when the site had exactly one lock)
    const isLockOutput = (pin) => (smartLocks || []).some(smartLock => smartLock && String(smartLock.outputPin) === String(pin));

    // get all outputs of type latch
    let LatchPins = OutPutsPinNames.filter(outPut => !isLockOutput(outPut.Pin));

    setLatchPins(LatchPins);

    // get all pulse pins
    const pulsePins = OutPutsPinNames.filter(outPut => outPut.type == 'PULSE');

    // set the pins in holidayDetails.states object to "pulse", if the are of type pulse
    if (pulsePins.length != 0) {
      pulsePins.map((pulseOutput) => {
        HandleOutputState(pulseOutput.Pin, "pulse");
      })
    }

    // get all pins that have dosmartlock assinged to it
    let smartLockPins = OutPutsPinNames.filter(outPut => isLockOutput(outPut.Pin));

    // for all pins that have a smart lock assinged to them, set the states of thoese pins to "lock" within holidaymode details.
    if (smartLockPins.length != 0) {
      smartLockPins.map((smartLockOutput) => {
        HandleOutputState(smartLockOutput.Pin, "lock");
      })
    }


  }, [])
  return (
    <>
      <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>

        <div className={classes.editContainer}>
          <ToggleInput
            label={"Active"}
            ref={activeButtonRef}
            type="checkbox"
            isChecked={isHolidayModeActive}
            setIsChecked={setIsHolidayModeActive}
          />

          <TimeDatePicker handler={HandleStartOn} label={"Start at:"} preSelectedDateTime={holidayModeDetails.start} timeZone={holdiayMode.timezone} />
          {isStartInvalid && (
            <p style={{ color: "rgb(220,114,119)", margin: "4px 0 0", fontSize: "13px" }}>{TEMP_SCHEDULE_START_ERROR}</p>
          )}
          <TimeDatePicker handler={HandleEndOn} label={"End at:"} preSelectedDateTime={holidayModeDetails.end} timeZone={holdiayMode.timezone} />

          <h3>What should the switch do during the temporary schedule?</h3>

          {latchPins && latchPins.map((outPut, index) => {
            if (outPut.type == "LATCH" || outPut.type == "VIRTUAL_LATCH"){
              return (
                <StatePicker index={index} pinText={outPut.pinName} outputPin={outPut.Pin} HandleOutputState={HandleOutputState} states={holidayModeDetails.states[outPut.Pin]} />
              )
            }
          })}

          <div className={classes.buttonContainer}>
            {(role === "admin" || role === "TechSupport") && <Button1 onClick={HandleRemoveHolidayMode}>Remove</Button1>}
            <Button1 onClick={HandleEditHolidayMode} >Save</Button1 >
          </div>
        </div >
      </Modal>

      <RuleCard
         header={`Temporary schedule`}
         subHeader={holdiayMode.name}
         onClick={() => HandleShowModal()}
         meta={[`${UseParseDateMonthYearTime(holdiayMode.start, holdiayMode.timezone)} - ${UseParseDateMonthYearTime(holdiayMode.end, holdiayMode.timezone)}`]}
         active={holdiayMode.active}
          footer={
            createdBy && dateCreated
              ? `Created by ${UseDisplayUserName(createdBy.fullName)} on ${format(
                  new Date(dateCreated),
                  "MMM do, yyyy - HH:mm"
                )}`
              : null
          }           />

      
    </>
  )
}

export default HolidayModeCardContentLayout